import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoadingErrorBlockComponent } from '@app/components/loading-error-block/loading-error-block.component';
import { HeadMetaComponent } from '@app/components/ui.component';
import { Webhook } from '@app/models/webhook.interface';
import { AuthService } from '@app/services/auth.service';
import { WebhookHelperService } from '@app/services/helpers/webhook-helper.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { 
  faCirclePlus,
  faArrowLeft 
 } from '@fortawesome/free-solid-svg-icons';
import { LetDirective } from '@ngrx/component';
import { Observable } from 'rxjs';
import { HelpButtonComponent } from "@app/components/help-button/help-button.component";

@Component({
    selector: 'app-webhooks',
    imports: [
        HeadMetaComponent,
        LetDirective,
        LoadingErrorBlockComponent,
        FontAwesomeModule,
        RouterModule,
        HelpButtonComponent
    ],
    templateUrl: './listing.page.html',
    styleUrl: './listing.page.scss'
})
export class WebhooksPage {
  public title = 'Webhooks';
  webhooks$: Observable<Webhook[]>;

  faCirclePlus = faCirclePlus;
  faArrowLeft = faArrowLeft;

  constructor(
    private webhookHelper: WebhookHelperService,
    public auth: AuthService,
  ) {
    this.webhooks$ = this.webhookHelper.getAll();
  }
}
